import { Children, isValidElement, ReactNode } from 'react';

const MdxAlertText = ({ children, ...props }) => {
	const nodes = Children.toArray(children);
	const content =
		nodes.length === 1 && isValidElement<{ children?: ReactNode }>(nodes[0]) && nodes[0].type === 'p'
			? nodes[0].props.children
			: children;
	return (
		<p {...props} className='text-sm text-foreground-body'>
			{content}
		</p>
	);
};
export { MdxAlertText };
